import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { Alert, Container, Icon, Panel, Tooltip, Whisper } from 'rsuite';
import {
  getCompetitiviteData,
  getDetailsData,
  getDownloadIndustry,
  getDownloadRetail,
  getEvolutionData,
  getIndustryCompetitiviteData,
  getIndustryDetailsData,
  getIndustryEvolutionData,
  resetToInitialState,
  setSingleReducer,
} from '../../../../actions/actionsAnaliseCompetitividade';
import Header from '../../../../components/Header';
import { LoadingSpinerArea } from '../../../../components/LoadingSpinner';
import ModalConfirm from '../../../../components/ModalConfirm';
import { ModalSpeakWithSpecialist } from '../../../../components/ModalSpeakWithSpecialist';
import { ModalVideos } from '../../../../components/ModalVideos/ModalVideos';
import { trackEvent } from '../../../../utils/MatomoConfig';
import { MonitoramentoTipo } from '../CentralDeMonitoramento/types';
import { sendLead } from '../InfoPanel/utils';
import HowToUseModuleReportBanner from '../ModuloRelatorio/Components/HowToUseModuleReportBanner';
import {
  ButtonVideo,
  Detailing,
  EmptyState,
  FiltersArea,
  GeneralAverageBox,
  ModalCalculationInfoContent,
  ModalProductCalculationInfoContent,
  MonitorButton,
  QuantityBox,
  ReferenceBox,
  ResultsButton,
  TimeEvolutionChart,
} from './Components';

import { INFOPANEL_CTA_LINK } from '../../../../utils/constants';
import { PageBlocker } from '../InfoPanel/Components/PageBlocker';
import styles from './styles.module.scss';
import { dataVideoModuleReportModal, getComparisonScopeConfig, stringLimited, tooltipCalculationText, videosData } from './utils';

const pageBlockerStyle = {
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
};

const AnaliseCompetitividade = ({ usuario }) => {
  const [showModalUnderstandCalculation, setShowModalUnderstandCalculation] = useState(false);
  const [showModalVideoss, setShowModalVideoss] = useState(false);

  const location = useLocation();
  const competitionType = location.pathname.split('/').pop();
  const isRetail = competitionType === 'varejo';

  const hasNoPermission = !usuario?.tipoAdicionalContratos?.PAN?.includes('MODULO_COMPETITIVIDADE');
  const hasMonitoramentoContratado = usuario?.tipoAdicionalContratos?.PAN?.includes('MONITORAMENTO_E_ALERTAS');

  const {
    analiseCompetitividadeData,
    competitividadeResponse,
    evolutionResponse,
    hasResults,
    loadingPage,
    loadingChart,
    isEmptyResponse,
    detailsResponse,
    productsResponse,
    analiseCompetitividadeExecutada,
    servicoPainel,
    productLabel,
    analiseIndustriaCompetitividadeData,
    clienteData,
    filterIsEmpty,
    preferences,
    showModalSpeakWithSpecialistAnaliseCompetitividade,
  } = useSelector(
    state => ({
      clienteData: state.clienteDataReducer?.clienteData,
      analiseCompetitividadeData: state.analiseCompetitividadeDataReducer.analiseCompetitividadeData,
      analiseIndustriaCompetitividadeData: state.analiseCompetitividadeDataReducer.analiseIndustriaCompetitividadeData,
      competitividadeResponse: state.analiseCompetitividadeDataReducer.competitividadeResponse,
      evolutionResponse: state.analiseCompetitividadeDataReducer.evolutionResponse,
      hasResults: state.analiseCompetitividadeDataReducer.hasResults,
      loadingPage: state.analiseCompetitividadeDataReducer.loadingPage,
      loadingChart: state.analiseCompetitividadeDataReducer.loadingChart,
      isEmptyResponse: state.analiseCompetitividadeDataReducer.isEmptyResponse,
      detailsResponse: state.analiseCompetitividadeDataReducer.detailsResponse,
      productsResponse: state.analiseCompetitividadeDataReducer.productsResponse,
      analiseCompetitividadeExecutada: state.analiseCompetitividadeDataReducer.analiseCompetitividadeExecutada,
      productLabel: state.analiseCompetitividadeDataReducer.productLabel,
      servicoPainel: state.usuarioDataReducer.servicoPainel,
      filterIsEmpty: state.analiseCompetitividadeDataReducer.filterIsEmpty,
      preferences: state.analiseCompetitividadeDataReducer.preferences,
      showModalSpeakWithSpecialistAnaliseCompetitividade: state.analiseCompetitividadeDataReducer.showModalSpeakWithSpecialistAnaliseCompetitividade,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();

  const scopeConfig = getComparisonScopeConfig(analiseCompetitividadeData?.tipoComparacao);
  const resultScopeConfig = getComparisonScopeConfig(analiseCompetitividadeExecutada?.tipoComparacao);

  const hasScopeFilled = scopeConfig.filtroField === null || analiseCompetitividadeData?.[scopeConfig.filtroField]?.length !== 0;

  const hasFilterfilled =
    hasScopeFilled &&
    analiseCompetitividadeData?.periodoSemanas !== 0 &&
    analiseCompetitividadeData?.redeReferencia !== null &&
    analiseCompetitividadeData?.redesCompetidoras?.length !== 0 &&
    analiseCompetitividadeData?.tipoLocalizacao !== null;

  const hasIndustryFilterfilled =
    analiseIndustriaCompetitividadeData?.produtoReferencia !== null &&
    analiseIndustriaCompetitividadeData?.produtosCompetidores?.length !== 0 &&
    analiseIndustriaCompetitividadeData?.periodoSemanas !== 0 &&
    analiseIndustriaCompetitividadeData?.redes?.length !== 0 &&
    analiseIndustriaCompetitividadeData?.tipoLocalizacao !== null;

  const evolutionModel = {
    agrupamentoEvolucao: isRetail ? 'REDE' : 'PRODUTO',
    preenchimentoEvolucao: 'PREENCHER_E_REPLICAR',
    request: isRetail ? analiseCompetitividadeData : analiseIndustriaCompetitividadeData,
  };

  const sendCTA = () => {
    sendLead(usuario, 'upsell-competitividade');
    trackEvent('Upsell/Crossell', 'upsell-block-competitividade');
    dispatch(setSingleReducer('showModalSpeakWithSpecialistAnaliseCompetitividade', false));
    window.open(INFOPANEL_CTA_LINK);
  };

  const handleViewResults = () => {
    const locationType = analiseCompetitividadeData?.tipoLocalizacao;
    const locationList = analiseCompetitividadeData?.listaLocalizacao;

    if (hasFilterfilled) {
      dispatch(setSingleReducer('evolutionResponse', []));
      trackEvent('Competitividade de Varejo', 'Visualizar resultados');

      if (locationType !== 'TODO_TERRITORIO' && locationList?.length !== 0) {
        dispatch(getCompetitiviteData(analiseCompetitividadeData));
        dispatch(getEvolutionData(evolutionModel, 'page'));
        dispatch(getDetailsData(analiseCompetitividadeData));
      } else if (locationType === 'TODO_TERRITORIO' && locationList?.length === 0) {
        dispatch(getCompetitiviteData(analiseCompetitividadeData));
        dispatch(getEvolutionData(evolutionModel, 'page'));
        dispatch(getDetailsData(analiseCompetitividadeData));
      } else {
        Alert.warning('Para visualizar os resultados, defina todos os campos de busca', 5000);
      }
    } else {
      Alert.warning('Para visualizar os resultados, defina todos os campos de busca', 5000);

      dispatch(
        setSingleReducer('filterIsEmpty', {
          ...filterIsEmpty,
          tipoLocalizacao: analiseCompetitividadeData?.tipoLocalizacao === null,
          ...(scopeConfig.filtroField ? { [scopeConfig.filtroField]: analiseCompetitividadeData?.[scopeConfig.filtroField]?.length === 0 } : {}),
          periodoSemanas: analiseCompetitividadeData?.periodoSemanas === 0,
          redeReferencia: analiseCompetitividadeData?.redeReferencia === null,
          redesCompetidoras: analiseCompetitividadeData?.redesCompetidoras?.length === 0,
          listaLocalizacao: analiseCompetitividadeData?.listaLocalizacao?.length === 0,
        }),
      );
    }
  };

  const handleViewIndustryResults = () => {
    const locationType = analiseIndustriaCompetitividadeData?.tipoLocalizacao;
    const locationList = analiseIndustriaCompetitividadeData?.listaLocalizacao;

    trackEvent('Competitividade de Produto', 'Visualizar resultados');

    if (hasIndustryFilterfilled) {
      dispatch(setSingleReducer('evolutionResponse', []));
      if (locationType !== 'TODO_TERRITORIO' && locationList?.length !== 0) {
        dispatch(getIndustryCompetitiviteData(analiseIndustriaCompetitividadeData));
        dispatch(getIndustryEvolutionData(evolutionModel, 'page'));
        dispatch(getIndustryDetailsData(analiseIndustriaCompetitividadeData));
      } else if (locationType === 'TODO_TERRITORIO' && locationList?.length === 0) {
        dispatch(getIndustryCompetitiviteData(analiseIndustriaCompetitividadeData));
        dispatch(getIndustryEvolutionData(evolutionModel, 'page'));
        dispatch(getIndustryDetailsData(analiseIndustriaCompetitividadeData));
      } else {
        Alert.warning('Para visualizar os resultados, defina todos os campos de busca', 5000);
      }
    } else {
      Alert.warning('Para visualizar os resultados, defina todos os campos de busca', 5000);

      dispatch(
        setSingleReducer('filterIsEmpty', {
          ...filterIsEmpty,
          tipoLocalizacao: analiseIndustriaCompetitividadeData?.tipoLocalizacao === null,
          periodoSemanas: analiseIndustriaCompetitividadeData?.periodoSemanas === 0,
          listaLocalizacao: analiseIndustriaCompetitividadeData?.listaLocalizacao?.length === 0,
          produtoReferencia: analiseIndustriaCompetitividadeData?.produtoReferencia === null,
          produtosCompetidores: analiseIndustriaCompetitividadeData?.produtosCompetidores?.length === 0,
          redes: analiseIndustriaCompetitividadeData?.redes?.length === 0,
        }),
      );
    }
  };

  const handleOnClickChartViewChange = type => {
    if (type === 'general') {
      const generalData = {
        ...evolutionModel,
        agrupamentoEvolucao: 'GERAL',
      };
      if (isRetail) {
        dispatch(getEvolutionData(generalData, 'chart'));
      } else {
        dispatch(getIndustryEvolutionData(generalData, 'chart'));
      }
    } else if (isRetail) {
      dispatch(getEvolutionData(evolutionModel, 'chart'));
    } else {
      dispatch(getIndustryEvolutionData(evolutionModel, 'chart'));
    }
  };

  const handleDownload = extension => {
    if (hasFilterfilled && isRetail) {
      dispatch(getDownloadRetail(extension, analiseCompetitividadeData));
    }

    if (hasIndustryFilterfilled && !isRetail) {
      dispatch(getDownloadIndustry(extension, analiseIndustriaCompetitividadeData));
    }
  };

  const industryLabelWithTooltip = label => (
    <Whisper trigger="hover" placement="top" speaker={<Tooltip>{label}</Tooltip>}>
      <p className={styles['item-name']}>{stringLimited(label)}</p>
    </Whisper>
  );

  useEffect(() => {
    if (location.state?.competitivityFilterDTO) {
      dispatch(setSingleReducer('evolutionResponse', []));
      dispatch(setSingleReducer('detailsResponse', []));
      dispatch(setSingleReducer('productsResponse', {}));
      dispatch(setSingleReducer('isEmptyResponse', false));
      dispatch(setSingleReducer('hasResults', false));
      dispatch(
        setSingleReducer('competitividadeResponse', {
          competitividadeMedia: 0,
          lojasRedeReferencia: 0,
          produtosComparados: 0,
          redesEncontradas: 0,
        }),
      );
    } else {
      dispatch(resetToInitialState());
    }
  }, []);

  const handleShowModalVideos = () => {
    setShowModalVideoss(!showModalVideoss);
  };

  return (
    <Container className="main-container analise-competitividade">
      <div id="container">
        <Header
          title="Análise de competitividade"
          subtitle="Compare preços e analise a competitividade entre redes."
          textButton="Entenda como calculamos"
          icon={<Icon icon="trophy" />}
          onClickTextButton={() => setShowModalUnderstandCalculation(true)}
          rightChildren={<ButtonVideo onClick={handleShowModalVideos} />}
        />
        {hasNoPermission ? (
          <HowToUseModuleReportBanner
            onClickModal={handleShowModalVideos}
            dataVideo={dataVideoModuleReportModal}
            title={
              <>
                <p>Conheça o Análise</p>
                <p>de competitividade</p>
              </>
            }
            subtitle={
              <>
                Tenha uma visão estratégica da competitividade entre redes
                <br />
                varejistas ou entre produtos similares.
              </>
            }
          />
        ) : null}
        <div className={styles['content-area']}>
          <FiltersArea />
          <ResultsButton
            onClick={isRetail ? handleViewResults : handleViewIndustryResults}
            onClickDownload={handleDownload}
            downloadDisabled={isRetail ? !hasFilterfilled : !hasIndustryFilterfilled}
            hasDataRendered={hasResults}
          />
          {/* hasNoPermission aqui é o módulo de Competitividade (já existente), diferente do
          hasMonitoramentoContratado (módulo de Monitoramento) tratado dentro do MonitorButton. */}
          {!hasNoPermission && (
            <MonitorButton
              visible={hasResults}
              tipo={isRetail ? MonitoramentoTipo.COMPETITIVIDADE_VAREJO : MonitoramentoTipo.COMPETITIVIDADE_PRODUTO}
              filtros={evolutionModel.request}
              preferences={preferences}
              hasModuloContratado={hasMonitoramentoContratado}
              usuario={usuario}
            />
          )}
          {hasNoPermission ? (
            <PageBlocker
              id="analise-competitividade-blocker-btn"
              title="Avalie sua competitividade em relação aos produtos e lojas dos concorrentes."
              subtitle="Disponível em outros planos do InfoPanel."
              buttonText="quero o teste grátis"
              style={pageBlockerStyle}
              onClick={() => dispatch(setSingleReducer('showModalSpeakWithSpecialistAnaliseCompetitividade', true))}
            />
          ) : null}
        </div>
      </div>
      {loadingPage ? <LoadingSpinerArea /> : null}
      {hasResults ? (
        <div className={styles['results-container']}>
          <div className={styles['graphic-container']}>
            <ReferenceBox
              name={isRetail ? analiseCompetitividadeData.redeReferencia : industryLabelWithTooltip(productLabel)}
              product={isRetail ? null : analiseIndustriaCompetitividadeData.produtoReferencia}
              badgeText="referência"
              className={styles['grid-reference']}
            />
            <GeneralAverageBox
              className={styles['grid-average']}
              data={(competitividadeResponse?.competitividadeMedia || 0) * 100}
              scopeText={isRetail ? 'Competitividade média versus as redes selecionadas' : 'Competitividade média versus os produtos selecionados'}
            />
            <Whisper trigger="hover" placement="right" speaker={<Tooltip>{tooltipCalculationText}</Tooltip>}>
              <span>
                <QuantityBox
                  quantity={isRetail ? competitividadeResponse.produtosComparados : competitividadeResponse.redesComparadas}
                  quantitySelected={
                    isRetail ? analiseCompetitividadeExecutada?.[resultScopeConfig.filtroField]?.length : analiseIndustriaCompetitividadeData?.redes?.length
                  }
                  title={isRetail ? resultScopeConfig.quantityBoxTitle : 'Redes encontradas'}
                  className={styles['grid-compare']}
                />
              </span>
            </Whisper>
            <Whisper trigger="hover" placement="right" speaker={<Tooltip>{tooltipCalculationText}</Tooltip>}>
              <span>
                <QuantityBox
                  quantity={isRetail ? competitividadeResponse.redesEncontradas : competitividadeResponse.produtosEncontrados}
                  quantitySelected={
                    isRetail ? analiseCompetitividadeData?.redesCompetidoras?.length : analiseIndustriaCompetitividadeData?.produtosCompetidores?.length
                  }
                  title={isRetail ? 'Redes encontradas' : 'Produtos encontrados'}
                  className={styles['grid-found']}
                />
              </span>
            </Whisper>

            <div className={styles['grid-time-evolution']}>
              <TimeEvolutionChart
                usuario={usuario}
                chartData={evolutionResponse}
                onClickViewChange={handleOnClickChartViewChange}
                loadingChart={loadingChart}
                competitionType={competitionType}
                redes={analiseIndustriaCompetitividadeData?.redes?.length}
                itemPluralLabel={resultScopeConfig.itemPluralLabel}
              />
            </div>
          </div>
          <Detailing dataPanelHeader={detailsResponse} dataTable={productsResponse} competitionType={competitionType} scopeConfig={resultScopeConfig} />
        </div>
      ) : null}
      {isEmptyResponse ? <EmptyState /> : null}
      <ModalConfirm
        show={showModalUnderstandCalculation}
        modalWidth="700px"
        titleFontSize="16px"
        footerAlign="end"
        closeButton={false}
        title="Entenda como calculamos a competitividade"
        confirmButton="Fechar"
        onConfirm={() => setShowModalUnderstandCalculation(false)}
        className={styles['modal-understand-how']}
      >
        <Panel header="Competitividade entre varejos" collapsible bordered className={styles['modal-understand-how-content-panel']}>
          <ModalCalculationInfoContent />
        </Panel>
        <Panel
          header="Competitividade entre produtos"
          collapsible
          bordered
          style={{ marginTop: '16px' }}
          className={styles['modal-understand-how-content-panel']}
        >
          <ModalProductCalculationInfoContent />
        </Panel>
      </ModalConfirm>
      <ModalVideos show={showModalVideoss} onHide={() => setShowModalVideoss(false)} videosData={videosData} />
      <ModalSpeakWithSpecialist
        show={showModalSpeakWithSpecialistAnaliseCompetitividade}
        title="Quer ter uma pesquisa de preço mais completa?"
        subtitle="Converse com os nossos especialistas para encontrar o melhor plano para sua necessidade."
        onClick={sendCTA}
        onCancel={() => dispatch(setSingleReducer('showModalSpeakWithSpecialistAnaliseCompetitividade', false))}
      />
    </Container>
  );
};

export default withRouter(AnaliseCompetitividade);
